export const SET_SOCIETY = 'SET_SOCIETY'
